import React, { useState, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Tabs, Tab, Badge, TextField, IconButton } from '@material-ui/core';
import { SearchIcon, CloseIcon } from 'components/Icons';
import Context from 'components/DuvidasFrequentes/Context';
import useDuvidasStyles from './style';
import List from './List';

export default function () {
  const { t } = useTranslation();
  const classes = useDuvidasStyles();
  const { perguntas, tab, changeTab } = useContext(Context);
  const [searchTerm, setTerm] = useState<string>('');

  const respondidoNaoLido = useMemo(() => {
    if (perguntas) {
      return perguntas.usuario.filter(pergunta => pergunta.resposta && !pergunta.lido).length;
    }
    return 0;
  }, [perguntas]);

  return (
    <Box className={classes.root}>
      <Box className={classes.pesquisa}>
        <TextField
          placeholder={t('search')}
          InputProps={{
            endAdornment:
              searchTerm.length > 0 ? (
                <IconButton onClick={() => setTerm('')} className={classes.clearIcon}>
                  <CloseIcon className={classes.searchIcon} />
                </IconButton>
              ) : (
                <SearchIcon className={classes.searchIcon} />
              ),
          }}
          value={searchTerm}
          onChange={e => setTerm(e.currentTarget.value)}
        />
      </Box>
      <Tabs
        value={tab}
        onChange={(e, value) => changeTab(value)}
        indicatorColor="primary"
        className={classes.tabs}
        variant="fullWidth"
      >
        <Tab label={t('AssembleiaAssociadoRoute.faq.public')} className={classes.tab} />

        <Tab
          label={
            <Badge
              anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
              badgeContent={respondidoNaoLido}
              variant="standard"
              color="error"
            >
              <span>{t('AssembleiaAssociadoRoute.faq.private')}</span>
            </Badge>
          }
          className={classes.tab}
        />
      </Tabs>
      <List onlyPrivate={tab === 1} searchTerm={searchTerm} />
    </Box>
  );
}
